module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["de","en"],"defaultLanguage":"de","fallbackLanguage":"de","siteUrl":"https://preview-v2.michaelshof-sammatz.de","i18nextOptions":{"appendNamespaceToMissingKey":true,"defaultNS":"common","interpolation":{"escapeValue":false},"ns":[]},"pages":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Michaels Hof Sammatz","short_name":"Hof Sammatz","start_url":"/","background_color":"#fff","lang":"de","display":"minimal-ui","icon":"src/images/favicon-hof.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"32b605cb5ec85cf19ef6d4e871b1ed2c"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
